function abreviarApellidos(nombre) {
  if (!nombre) {
    return nombre;
  }

  const piezas = nombre.split(' ');
  let resultado = piezas[0] || '';

  if (piezas[1]) {
    resultado += ` ${piezas[1][0].toUpperCase()}.`;
  }

  return resultado;
}

export {
  abreviarApellidos
};
